export const validator = {
    email: v => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(v) || 'Zadejte platný e-mail.'
    },
    password: v => v.length >= 6 || 'Heslo musí mít alespoň 6 znaků.',
    teamName: v => v.length >= 4 || 'Název týmu musí mít alespoň 4 znaky.',
    required: v => !!v || 'Toto pole musí být vyplněno.',
};
